module.exports = __webpack_public_path__ + "static/img/ambulancia-ucm-1.3aad6b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ambulancia-ucm-1.png
// module id = VXXd
// module chunks = 1